module.exports = __webpack_public_path__ + "media/packs/images/flags/CA-99aa913fabd7f638e25aa36a680a56d2.svg";